"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_PRODUCT_TREE_NODES_WITH_VALIDATORS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_ALL_PRODUCT_TREE_NODES_WITH_VALIDATORS = (0, gql_1.gql)(`
  query productTreeNodesWithValidators(
    $productTreeId: ID!,
    $filter: ProductTreeNodeFilter,
    $attributesFilter: ProductTreeNodeUniqueLabelListFilter,
    $skipValidators: Boolean = true
    $first: Int,
  ) {
    productTreeNodes(ancestralProductTreeId: $productTreeId, filter: $filter, first: $first) {
      edges {
        node {
          id
          title
          labelValidation(filter: $attributesFilter) @skip (if: $skipValidators) {
            edges {
              node {
                label
              }
            }
          }
        }
      }
    }
  }
`);
